module.exports = __webpack_public_path__ + "static/img/not-satified-01.2af458d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/not-satified-01.jpg
// module id = 279
// module chunks = 1